import ApiClient from '@/services/apiClient';

export default class ReaderLedConfig {
    closed;
    open;
    alarm_on;
    denied;
    bluetooth;

    constructor() {
        this.closed = 0x00FF0000;
        this.open = 0x0000FF00;
        this.alarm_on = 0x00FFA500;
        this.denied = 0x0000FF00;
        this.bluetooth = 0x000000FF;
    }

    static constructFromObject(data, obj) {
        obj = obj || new ReaderLedConfig();
        if (data) {
            obj = obj || new ReaderLedConfig();
            obj.closed = ApiClient.convertToType(data['closed'], 'Integer') ?? 0x00FF0000;
            obj.open = ApiClient.convertToType(data['open'], 'Integer') ?? 0x0000FF00;
            obj.alarm_on = ApiClient.convertToType(data['alarm_on'], 'Integer') ?? 0x00FFA500;
            obj.denied = ApiClient.convertToType(data['denied'], 'Integer') ?? 0x0000FF00;
            obj.bluetooth = ApiClient.convertToType(data['bluetooth'], 'Integer') ?? 0x000000FF;
        }
        return obj;
    }

    toJSON() {
        return {
            closed: this.closed,
            open: this.open,
            alarm_on: this.alarm_on,
            denied: this.denied,
            bluetooth: this.bluetooth,
        };
    }
}
